import React from 'react';

import ReactMarkdown from 'react-markdown';

import { graphql } from 'gatsby';

import Hero from '../components/Hero';
import Layout from '../components/Layout';

function Impressum({ data }) {
    const { title, content } = data.allMarkdownRemark.nodes[0].frontmatter;
    return (
        <div>
            <Layout>
                <Hero text={ title } />
                <div className="container mx-auto px-4">
                    <div className="mt-8">
                        <ReactMarkdown>{ content }</ReactMarkdown>
                    </div>
                </div>
            </Layout> 
        </div>
    );
}

export default Impressum;

export const query = graphql`
query Impressum {
    allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/impressum/"}}) {
      nodes {
        fileAbsolutePath
        frontmatter {
          title
          content
        }
      }
    }
  }`